/* Collect by PW on product pages: shows whether this card is in the customer's collection
   and lets them tick it off without leaving the page. Reads the collection through a small
   bridge page on the Collect server (the same saved collection the Collect app uses). */
(function () {
  var cfg = window.PWC_COLLECT;
  if (!cfg || !cfg.sku || !/^[A-Z0-9]+-[^-]+\/[^-]+-[A-Z0-9]+-EN-/.test(cfg.sku)) return;

  var frame, ready, seq = 0, wait = {};
  function bridge() {
    if (ready) return ready;
    ready = new Promise(function (res) {
      frame = document.createElement('iframe');
      frame.src = cfg.origin + '/bridge.html';
      frame.title = 'Collect by PW';
      frame.setAttribute('aria-hidden', 'true');
      frame.tabIndex = -1;
      frame.style.cssText = 'position:absolute;width:1px;height:1px;border:0;opacity:0;pointer-events:none;left:-9999px';
      window.addEventListener('message', function (e) {
        if (e.origin !== cfg.origin || !e.data) return;
        if (e.data.pwc === 'bridge-ready') res();
        if (e.data.pwc === 'bridge-reply' && wait[e.data.id]) { wait[e.data.id](e.data); delete wait[e.data.id]; }
      });
      document.body.appendChild(frame);
      setTimeout(res, 4000);
    });
    return ready;
  }
  function ask(type) {
    return bridge().then(function () {
      return new Promise(function (res) {
        var id = ++seq; wait[id] = res;
        frame.contentWindow.postMessage({ pwc: 'bridge', type: type, sku: cfg.sku, id: id }, cfg.origin);
        setTimeout(function () { if (wait[id]) { delete wait[id]; res(null); } }, 6000);
      });
    });
  }

  var css = '.pwc-cbadge{margin:14px 0 4px;border-radius:16px;padding:14px 16px;background:linear-gradient(135deg,#e3f0f5,#fbf3ea);font:inherit;color:#15262c}' +
    '.pwc-cbadge__top{display:flex;align-items:center;gap:8px;font-size:12px;font-weight:700;letter-spacing:.08em;text-transform:uppercase;color:#2c5b65}' +
    '.pwc-cbadge__top svg{width:18px;height:18px}' +
    '.pwc-cbadge__msg{margin:6px 0 0;font-weight:700;font-size:15px;line-height:1.35}' +
    '.pwc-cbadge__sub{margin:2px 0 0;font-size:13px;color:#4a5c63}' +
    '.pwc-cbadge__bar{height:6px;border-radius:6px;background:rgba(255,255,255,.8);margin-top:8px;overflow:hidden}' +
    '.pwc-cbadge__bar i{display:block;height:100%;background:#5696a0;border-radius:6px;transition:width .6s cubic-bezier(.2,.9,.3,1)}' +
    '.pwc-cbadge__row{display:flex;gap:8px;flex-wrap:wrap;margin-top:10px}' +
    '.pwc-cbadge__row a,.pwc-cbadge__row button{font:inherit;font-size:13px;font-weight:700;border-radius:999px;padding:8px 14px;min-height:38px;cursor:pointer;text-decoration:none;display:inline-flex;align-items:center}' +
    '.pwc-cbadge__own{background:#2c5b65;color:#fff;border:0}' +
    '.pwc-cbadge__open{background:#fff;color:#15262c;border:1px solid #d6e2e7}' +
    '.pwc-cbadge.is-owned{background:linear-gradient(135deg,#e6f3ec,#f6f0de)}' +
    '.pwc-cbadge.pop{animation:pwcPop .5s cubic-bezier(.3,1.6,.5,1)}@keyframes pwcPop{0%{transform:scale(.97)}60%{transform:scale(1.02)}100%{transform:none}}';

  function place(el) {
    var anchor = document.querySelector('product-form-component') || document.querySelector('form[action*="/cart/add"]');
    var host = anchor && (anchor.closest('.shopify-block, [class*="buy-buttons"]') || anchor);
    if (host && host.parentNode) host.parentNode.insertBefore(el, host.nextSibling);
    else (document.querySelector('main') || document.body).appendChild(el);
  }

  function render(el, a, justAdded) {
    if (!a || !a.found) { el.remove(); return; }
    var pct = a.setTotal ? Math.floor(a.setOwned / a.setTotal * 100) : 0;
    var link = cfg.collectUrl + '#' + a.code.toLowerCase();
    var msg, sub;
    if (a.hasVersion) {
      msg = justAdded ? 'Ticked off. It’s in your collection.' : 'You have this one in your collection.';
      sub = a.versions > 1 ? a.have + ' of ' + a.versions + ' versions of this card ticked off.' : '';
    } else {
      msg = a.started ? 'Missing from your collection.' : 'Track this card in Collect.';
      sub = a.started ? (a.have ? 'You have ' + a.have + ' of ' + a.versions + ' versions of this card.' : 'Got it already? Tick it off.') : 'Tick off the cards you have, see what you’re missing and buy the gaps from us.';
    }
    el.className = 'pwc-cbadge' + (a.hasVersion ? ' is-owned' : '') + (justAdded ? ' pop' : '');
    el.innerHTML =
      '<div class="pwc-cbadge__top"><svg viewBox="0 0 40 40" aria-hidden="true"><rect width="40" height="40" rx="11" fill="#b6ccd7"/><rect x="11.5" y="5" width="17" height="24" rx="3" fill="#3e7f89"/><path d="M6 21h28v8.5a6 6 0 0 1-6 6H12a6 6 0 0 1-6-6z" fill="#fff" fill-opacity=".85"/></svg>Collect by PW</div>' +
      '<p class="pwc-cbadge__msg"></p>' + (sub ? '<p class="pwc-cbadge__sub"></p>' : '') +
      (a.started || a.tracked ? '<p class="pwc-cbadge__sub pwc-cbadge__set"></p><div class="pwc-cbadge__bar"><i style="width:0"></i></div>' : '') +
      '<div class="pwc-cbadge__row">' + (a.hasVersion ? '' : '<button type="button" class="pwc-cbadge__own">I have this</button>') +
      '<a class="pwc-cbadge__open" href="' + link + '">' + (a.started ? 'Open ' + a.set : 'Start collecting') + '</a></div>';
    el.querySelector('.pwc-cbadge__msg').textContent = msg;
    if (sub) el.querySelector('.pwc-cbadge__sub').textContent = sub;
    var setLine = el.querySelector('.pwc-cbadge__set');
    if (setLine) {
      setLine.textContent = a.set + ' master set: ' + a.setOwned + ' of ' + a.setTotal + ' versions (' + pct + '%)';
      requestAnimationFrame(function () { requestAnimationFrame(function () { el.querySelector('.pwc-cbadge__bar i').style.width = pct + '%'; }); });
    }
    var own = el.querySelector('.pwc-cbadge__own');
    if (own) own.addEventListener('click', function () {
      own.disabled = true; own.textContent = 'Adding…';
      ask('own').then(function (b) { render(el, b, true); });
    });
  }

  function start() {
    var style = document.createElement('style'); style.textContent = css; document.head.appendChild(style);
    var el = document.createElement('div'); el.className = 'pwc-cbadge'; el.setAttribute('aria-live', 'polite');
    ask('check').then(function (a) { if (a && a.found) { place(el); render(el, a); } });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
